import { useEffect, useRef } from 'react'
import { useAuth } from '../hooks/useAuth'
import { LoadingSpinner } from '@/components/common/LoadingSpinner'
import { TOKEN_TYPE, getTokenFromCookies, clearAllTokens } from '@/lib/cookies'
import { redirectToSSOLogin } from '@/lib/sso'

interface AuthGuardProps {
  children: React.ReactNode
  requireAdminAccess?: boolean
}

export const AuthGuard: React.FC<AuthGuardProps> = ({
  children,
  requireAdminAccess = false,
}) => {
  const { isAuthenticated, user, isLoading, hasAdminAccess } = useAuth()
  const redirecting = useRef(false)

  useEffect(() => {
    if (isLoading || isAuthenticated || redirecting.current) return

    // Nếu còn access token hợp lệ → useAuth đang xử lý, chờ
    if (getTokenFromCookies(TOKEN_TYPE.ACCESS_TOKEN)) return

    // Không có access token (dù có hay không refresh token) → redirect SSO
    redirecting.current = true
    clearAllTokens()
    redirectToSSOLogin()
  }, [isLoading, isAuthenticated])

  if (isLoading) {
    return <LoadingSpinner />
  }

  if (!isAuthenticated) {
    return <LoadingSpinner />
  }

  if (requireAdminAccess && !hasAdminAccess()) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Truy cập bị từ chối</h1>
          <p className="text-gray-600 mb-6">
            Bạn không có quyền truy cập trang này. Yêu cầu quyền Admin.
          </p>
          <p className="text-sm text-gray-500">
            Role hiện tại: <span className="font-medium">{user?.role}</span>
          </p>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
